import React, { Component } from 'react';
import ReactDataGrid from 'react-data-grid';
import { Toolbar, Data } from 'react-data-grid-addons';
import { Field } from 'redux-form';
import { Translate } from 'react-redux-i18n';
import { SkyLightStateless } from 'react-skylight';
import { Grid, Row, Col, Panel, Button, Breadcrumb, ButtonToolbar } from 'react-bootstrap';

import Spinner from '../Widgets/spinner';
import { getFromToDates } from '../Common/cleanDates';
import ConfirmActionModal from '../Common/confirmActionModal';
import { DatePicker } from '../Common/datePicker';
import ContentWrapper from '../Layout/ContentWrapper';
import SetWeightModal from '../../containers/Dispatch/setWeightModal';
import { ROOT_URL } from '../../actions/root_url';

class Shipping extends Component {
  static contextTypes = {
    router: React.PropTypes.object
  };

  constructor() {
    super();
    this.state = {
      // Control state of Modal
      confirmActionOpen: false,
      setWeightOpen: false,

      orderNum: '',
      customerName: '',
      totalLoaded: null,
      rowChosen: null,
      currentRow: null,

      products: {
        rows: [],
        selectedRows: [],
        filters: {},
        sortColumn: null,
        sortDirection: null,
      },

      salesOrders: {
        rows: [],
        sortColumn: null,
        sortDirection: null,
      },
    };

    this.openSetWeight = this.openSetWeight.bind(this);
    this.closeSetWeight = this.closeSetWeight.bind(this);
    this.openAction = this.openAction.bind(this);
    this.closeAction = this.closeAction.bind(this);
  }

  componentDidMount() {
    // Grab salesOrders to choose from
    this.props.fetchSalesOrdersByDate(getFromToDates(new Date));
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.salesOrders && nextProps.salesOrders !== this.props.salesOrders) {
      const salesOrders = { ...this.state.salesOrders, rows: nextProps.salesOrders.SO };
      if (this.state.orderNum) {
        for (let i = 0; i < salesOrders.rows.length; i++) {
          if (salesOrders.rows[i].SONum === this.state.orderNum) {
            salesOrders.rows[i].selected = true;
            break;
          }
        }
      }
      this.setState({ salesOrders });
    }

    if (nextProps.chosenOrderNum && nextProps.chosenOrderNum !== this.props.chosenOrderNum) {
      this.props.fetchSalesOrderDetail(nextProps.chosenOrderNum.value);
    }

    if (nextProps.salesOrderDetail && nextProps.salesOrderDetail !== this.props.salesOrderDetail) {
      let products = {};
      if (nextProps.salesOrderDetail.Sales_Order_Lines) {
        products = { ...this.state.products, rows: nextProps.salesOrderDetail.Sales_Order_Lines };
      }
      this.setState({ products })
    }

    if (nextProps.ShippingDate && nextProps.ShippingDate !== this.props.ShippingDate) {
      this.props.fetchSalesOrdersByDate(getFromToDates(nextProps.ShippingDate));
    }
  }

  closeSetWeight() {
    this.setState({ setWeightOpen: false });
  }

  openSetWeight() {
    this.setState({ setWeightOpen: true });
  }

  openAction() {
    this.setState({ confirmActionOpen: true });
  }

  closeAction() {
    this.setState({ confirmActionOpen: false });
  }

  formatDate(date) {
    let formattedDate;
    if (date.getMonth() < 9) { // getMonth returns 0-11
      formattedDate = '0' + (parseInt(date.getMonth())+1);
    } else {
      // TURN THESE TO STRINGS
      formattedDate = String(parseInt(date.getMonth()+1));
    }

    if (date.getDate() < 10) {
      formattedDate += '0' + date.getDate();
    } else {
      formattedDate += String(date.getDate());
    }

    formattedDate += String(date.getFullYear());
    return formattedDate;
  }

  createInvoice() {
    this.props.convertToInvoice(this.props.salesOrderDetail.SalesOrder_id, this.state.products.rows)
      .then(() => {
        if (this.props.ShippingDate)
          this.props.fetchSalesOrdersByDate(getFromToDates(this.props.ShippingDate));
        else {
          this.props.fetchSalesOrdersByDate(getFromToDates(new Date()));
        }
      });
    const products = { ...this.state.products, rows: [], sortColumn: null, sortDirection: null, orderNum: null };
    this.setState({ products });
  }

  autoLoad() {
    let productRows = [...this.state.products.rows];
    productRows.map((row) => {
      if (row.ProductType === 'Fixed' || row.ProductType === 'Per-Pound') {
        if (row.LoadedQuantity === 0) {
          row.LoadedQuantity = row.Quantity;
          row.TotalWeight = parseFloat(row.LoadedQuantity) * parseFloat(row.NetWeight);
          row.TotalNetWeight = parseFloat(row.LoadedQuantity) * parseFloat(row.NetWeight);
        }
      }
      if (row.ProductType === 'Fixed') {
        row.TotalPrice = roundTo(parseFloat(row.LoadedQuantity) * parseFloat(row.UnitPrice), 2);
      }
      if (row.ProductType === 'Per-Pound') {
        row.TotalPrice = roundTo(parseFloat(row.TotalNetWeight) * parseFloat(row.UnitPrice), 2);
      }
    });

    const products = { ...this.state.products, rows: productRows };
    this.setState({ products });
  }

  checkRows() {
    let valid = true;

    this.state.products.rows.map((row) => {
      if (row.LoadedQuantity === 0) {
        this.setState({ confirmActionOpen: true });
        valid = false;
      }
    });
    if (valid) { this.createInvoice(); }
  }

  returnTotalWeight(totalWeight, weights) {
    const products = { ...this.state.products };
    products.rows[this.state.currentRow].TotalNetWeight = parseFloat(totalWeight);
    products.rows[this.state.currentRow].TotalWeight = parseFloat(totalWeight);
    products.rows[this.state.currentRow].Weights = weights;
    products.rows[this.state.currentRow].TotalPrice = roundTo(parseFloat(totalWeight) * parseFloat(products.rows[this.state.currentRow].UnitPrice), 2);
    this.setState({ products });
  }

  keepLoaded = (oldLoaded) => {
    const products = { ...this.state.products };
    products.rows[this.state.currentRow].LoadedQuantity = oldLoaded;
    this.setState({ products });
  }

  renderSalesOrderSelection() {
    if (this.props.salesOrdersIsLoading && !this.props.salesOrdersError) return <Spinner />
    else if (this.props.salesOrdersError) return <ContentWrapper><div className="alert alert-danger">{JSON.stringify(this.props.salesOrdersError)}</div></ContentWrapper>

    // Parameters of the react-data-grid
    const tableHeight = (window.innerHeight < 900) ? 635 : 635;

    const getRows = () => Data.Selectors.getRows(this.state.salesOrders);

    const getSize = () => getRows().length;

    const rowGetter = (rowIdx) => {
      const rows = getRows();
      return rows[rowIdx];
    };

    // Handle the sortable function
    const handleGridSort = (sortColumn, sortDirection) => {
      const salesOrders = { ...this.state.salesOrders, sortColumn, sortDirection };
      this.setState({ salesOrders });
    };

    const onRowSelect = (rows) => {
      const salesOrders = { ...this.state.salesOrders, selectedRows: rows };
      this.setState({ salesOrders });
    };

    const onRowClick = (rowIdx, row) => {
      if (row) {
        const salesOrders = { ...this.state.salesOrders };
        this.setState({ orderNum: row.SONum, salesOrders, customerName: row.Deliver_CustomerName }, () => {
          if (this.props.ShippingDate) {
            this.props.fetchSalesOrdersByDate(getFromToDates(this.props.ShippingDate));
          } else {
            this.props.fetchSalesOrdersByDate(getFromToDates(new Date()));
          }
        });
        this.props.fetchSalesOrderDetail(row.SalesOrder_id);
      }
    };

    const onClearFilters = () => {
      // all filters removed
      const salesOrders = { ...this.state.salesOrders, filters: {} };
      this.setState({ salesOrders });
    };

    const handleFilterChange = (filter) => {
      const newFilters = Object.assign({}, this.state.salesOrders.filters);
      if (filter.filterTerm) {
        newFilters[filter.column.key] = filter;
      } else {
        delete newFilters[filter.column.key];
      }
      const salesOrders = { ...this.state.salesOrders, filters: newFilters };
      this.setState({ salesOrders });
    };

    const handleRowUpdated = (e) => {
      const rows = this.state.salesOrders.rows.slice(0);
      Object.assign(rows[e.rowIdx], e.updated);
      const salesOrders = { ...this.state.salesOrders, rows };
      this.setState({ salesOrders });
    };

    const RowRenderer = React.createClass({
      render: function() {
        if (this.props.row.selected) {
          return (
            <div style={{ color: 'blue' }}>
              <ReactDataGrid.Row ref="row" {...this.props} />
            </div>
          );
        }
        return (<div><ReactDataGrid.Row ref="row" {...this.props} /></div>);
      }
    });

    // Column difinition
    const columns = [
      {
        key: 'SONum',
        name: <Translate value="so_no" />,
        resizable: true,
        sortable: true,
        width: 130,
        filterable: true,
      },
      // {
      //     key: 'RouteNum',
      //     name: <Translate value="route_num" />,
      //     resizable: true,
      //     sortable: true,
      //     width: 110,
      //     filterable: true,
      // },
      {
        key: 'Deliver_CustomerName',
        name: <Translate value="customer_name" />,
        resizable: true,
        sortable: true,
        filterable: true,
      },
    ];

    return (
      <Row>
        <Col sm={12}>
          <div id="Shipping-dataGrid1">
            <ReactDataGrid
              rowKey="SalesOrder_id"
              onGridSort={handleGridSort}
              toolbar={<Toolbar enableFilter />}
              onAddFilter={handleFilterChange}
              onClearFilters={onClearFilters}
              columns={columns}
              rowHeight={25}
              rowGetter={rowGetter}
              rowsCount={getSize()}
              onRowClick={onRowClick}
              minHeight={tableHeight}
              onRowUpdated={handleRowUpdated}
              rowRenderer={RowRenderer}
              onRowSelect={onRowSelect}
            />
          </div>
        </Col>
      </Row>
    );
  }

  renderSalesOrderDetail() {
    const that = this;
    if (this.props.salesOrderIsLoading && !this.props.salesOrderError) return <Spinner />
    else if (this.props.salesOrderError) return <ContentWrapper><div className="alert alert-danger">{JSON.stringify(this.props.salesOrderError)}</div></ContentWrapper>

    // Parameters of the react-data-grid
    const tableHeight = (window.innerHeight < 900) ? 635 : 635;

    const getRows = () => Data.Selectors.getRows(this.state.products);

    const getSize = () => getRows().length;

    const rowGetter = (rowIdx) => {
      const rows = getRows();
      return rows[rowIdx];
    };

    const onClearFilters = () => {
      // all filters removed
      const products = { ...this.state.products, filters: {} };
      this.setState({ products });
    };

    const handleFilterChange = (filter) => {
      this.state.salesOrders.rows = this.props.salesOrders;
      const newFilters = Object.assign({}, this.state.products.filters);
      if (filter.filterTerm) {
        newFilters[filter.column.key] = filter;
      } else {
        delete newFilters[filter.column.key];
      }
      const products = { ...this.state.products, filters: newFilters };
      this.setState({ products });
    };

    // Handle the sortable function
    const handleGridSort = (sortColumn, sortDirection) => {
      const products = { ...this.state.products, sortColumn, sortDirection };
      this.setState({ products });
    };

    function onDoubleClick(row) {
      this.setState({ totalLoaded: row.loaded_quantity, setWeightOpen: true, rowChosen: row.salesOrderLine_id });
    }

    const handleRowUpdated = (e) => {
      const rows = getRows(); // this.state.products.rows.slice(0);
      if (this.state.rowIdx) {
        rows[this.state.rowIdx].selected = true;
      }
      Object.assign(rows[e.rowIdx], e.updated);
      if (rows[e.rowIdx].ProductType === 'Fixed' || rows[e.rowIdx].ProductType === 'Per-Pound') {
        if (rows[e.rowIdx].LoadedQuantity === '') {
          rows[e.rowIdx].TotalWeight = 0;
          rows[e.rowIdx].TotalNetWeight = 0;
          rows[e.rowIdx].TotalPrice = 0;
        } else {
          rows[e.rowIdx].TotalWeight = parseFloat(rows[e.rowIdx].LoadedQuantity) * parseFloat(rows[e.rowIdx].NetWeight);
          rows[e.rowIdx].TotalNetWeight = parseFloat(rows[e.rowIdx].LoadedQuantity) * parseFloat(rows[e.rowIdx].NetWeight);
        }
      }
      if (rows[e.rowIdx].ProductType === 'Fixed') {
        rows[e.rowIdx].TotalPrice = +roundTo(parseFloat(rows[e.rowIdx].LoadedQuantity) * parseFloat(rows[e.rowIdx].UnitPrice), 2);
      }
      if (rows[e.rowIdx].ProductType === 'Per-Pound'){
        rows[e.rowIdx].TotalPrice = +roundTo(parseFloat(rows[e.rowIdx].TotalNetWeight) * parseFloat(rows[e.rowIdx].UnitPrice), 2);
      }
      let products = { ...this.state.products, rows: rows }

      if (rows[e.rowIdx].ProductType === 'Fixed' || rows[e.rowIdx].ProductType === 'Per-Pound') {
        that.setState({ products, totalLoaded: rows[e.rowIdx].LoadedQuantity, rowChosen: rows[e.rowIdx].SalesOrderLine_id, currentRow: e.rowIdx });
      } else {
        that.setState({ products, totalLoaded: rows[e.rowIdx].LoadedQuantity, rowChosen: rows[e.rowIdx].SalesOrderLine_id, setWeightOpen: true, currentRow: e.rowIdx });
      }
    }

    const RowRenderer = React.createClass({

      PropTypes: {
        onDoubleClick: React.PropTypes.func,
      },

      render: function() {
        return (<ReactDataGrid.Row ref="row" {...this.props} onDoubleClick={this.props.onDoubleClick} />)
      }
    });

    // Custom Formatter component
    const IsVariableFormatter = React.createClass({
      render() {
        if (this.props.dependentValues.ProductType === 'Fixed') {
          return <span>{this.props.value} </span>
        } else if (this.props.dependentValues.ProductType === 'Non-Fixed') {
          return <span>{this.props.value} <label className="label label-success"><Translate value="non_fixed" /></label></span>;
        } else if (this.props.dependentValues.ProductType === 'Per-Pound') {
          return <span>{this.props.value} <label className="label label-primary"><Translate value="per_pound" /></label></span>;
        }
      },
    });

    // Column difinition
    const columns = [
      {
        key: 'ProductNum',
        name: <Translate value="product_num" />,
        resizable: true,
        sortable: true,
        width: 80,
        filterable: true,
      },
      {
        key: 'Name',
        name: <Translate value="prod_name" />,
        resizable: true,
        width: 220,
        sortable: true,
        filterable: true,
      },
      {
        key: 'Description',
        name: <Translate value="description" />,
        resizable: true,
        sortable: true,
        width: 150,
        filterable: true,
      },
      {
        key: 'MeasureUnit',
        name: <Translate value="mm_unit" />,
        resizable: true,
        sortable: true,
        width: 75,
        filterable: true,
      },
      {
        key: 'Quantity',
        name: <Translate value="qty" />,
        resizable: true,
        sortable: true,
        width: 60,
        formatter: IsVariableFormatter,
        getRowMetaData: row => row,
      },
      {
        key: 'LoadedQuantity',
        name: <Translate value="loaded_qty" />,
        resizable: true,
        sortable: true,
        width: 70,
        editable: true,
      },
      {
        key: 'TotalWeight',
        name: <Translate value="total_wt" />,
        resizable: true,
        sortable: true,
        width: 80,
      },
      {
        key: 'Batch_PONum',
        name: <Translate value="batch_num" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
    ];

    return (
      <Row>
        <Col sm={12}>
          <div id="Shipping-dataGrid2">
            <ReactDataGrid
              rowKey="Product_id"
              onGridSort={handleGridSort}
              toolbar={<Toolbar enableFilter={true} />}
              onAddFilter={handleFilterChange}
              onClearFilters={onClearFilters}
              columns={columns}
              rowHeight={25}
              headerRowHeight={45}
              enableCellSelect={true}
              rowGetter={rowGetter}
              rowsCount={getSize()}
              rowRenderer={<RowRenderer onDoubleClick={onDoubleClick} />}
              minHeight={tableHeight}
              onRowUpdated={handleRowUpdated}
            />
          </div>
        </Col>
      </Row>
    );
  }

  renderPrint() {
    let date = this.props.ShippingDate || new Date();
    const year = date.getFullYear();
    let month = date.getMonth() + 1;
    let day = date.getDate();
    if (month < 10) { month = "0" + month; }
    if (day < 10) { day = "0" + day; }
    date = "" + year + month + day;
    const shipping_url = ROOT_URL + 'v1/sale/printpickinglist/' + date + "?Bearer=" + localStorage.getItem('token');
    return (
      <span>
        <a className="btn btn-primary" href={shipping_url} style={{ marginLeft: '5px' }} ><em className="fa fa-print" /><Translate value="print_shipping" /></a>
      </span>
    );
  }

  render() {
    const createDialogStyle = {
      width: '500px',
      height: '600px',
      top: '45%',
      marginLeft: '-10%',
    };

    return (
    //---------------
    // Begin HTML: Create New/Edit shipping
    //---------------
      <ContentWrapper>
        <Breadcrumb>
          <Breadcrumb.Item>
            <Translate value="dispatch" />
          </Breadcrumb.Item>
          <Breadcrumb.Item active="true">
            <Translate value="shipping" />
          </Breadcrumb.Item>
        </Breadcrumb>
        <Grid id="dispatch-shipping">
          {/* <div className="content-heading"><Translate value="shipping" /></div> */}
          <Row>
            <Col xs={4}>
              <h1><Translate value="shipping_details" style={{ textTransform: 'uppercase' }} /></h1>
            </Col>
            <Col xs={8}>
              <h1><Translate value="sales_order_details" style={{ textTransform: 'uppercase' }} />
                {' '}
                <span style={{ backgroundColor: '#FFECB3' }}>
                  {
                    (this.state.orderNum) ?
                    '(' + this.state.orderNum + ') ' + this.state.customerName :
                    ''
                  }
                </span>
              </h1>
            </Col>
          </Row>
          <Row>
            <Col sm={4}>
              <Panel id="order-selection-panel">
                <ButtonToolbar className="table-buttons" style={{ marginBottom: '15px' }}>
                  <Col sm={4}>
                    <h4><Translate value="date_filter" /></h4>
                  </Col>
                  <Col xs={5}>
                    <Field name="ShippingDate" selected={new Date()} component={DatePicker} />
                  </Col>
                </ButtonToolbar>
                <Row>
                  {this.renderSalesOrderSelection()}
                </Row>
              </Panel>
            </Col>
            <Col sm={8}>
              <Panel id="shipping-detail-panel" className="position-relative">
                <ButtonToolbar className="table-buttons" style={{ left: 25 }}>
                  <Button
                    bsStyle="primary"
                    disabled={this.state.products.rows.length === 0}
                    onClick={() => this.autoLoad()}
                  >
                    <Translate value="auto_load" />
                  </Button>
                  <Button
                    bsStyle="success"
                    disabled={this.props.salesOrderDetail == null}
                    onClick={() => this.checkRows()}
                  >
                    <Translate value="Finish_Shipping" />
                  </Button>
                  { this.renderPrint() }
                </ButtonToolbar>
                <Row>
                  <Col sm={12}>
                    {this.renderSalesOrderDetail()}
                  </Col>
                </Row>
              </Panel>
            </Col>
          </Row>
          <SkyLightStateless
            dialogStyles={createDialogStyle}
            isVisible={this.state.setWeightOpen}
            onCloseClicked={() => {
              this.closeSetWeight();
            }}
            title="Set Product Weights"
          >
            <SetWeightModal
              closeC={this.closeSetWeight}
              keepLoaded={this.keepLoaded}
              totalLoaded={this.state.totalLoaded}
              rowChosen={this.state.rowChosen}
              returnTotalWeight={this.returnTotalWeight.bind(this)}
            />
          </SkyLightStateless>
          <SkyLightStateless
            dialogStyles={createDialogStyle}
            isVisible={this.state.confirmActionOpen}
            onCloseClicked={() => {
              this.closeAction()
            }}
            title="Confirm Action"
          >
            <ConfirmActionModal
              closeC={this.closeAction}
              case={"quantityZero"}
              caseAction={this.createInvoice.bind(this)}
            />
          </SkyLightStateless>
        </Grid>
      </ContentWrapper>
    );
  }
}

export default Shipping;

function roundTo(n, digits) {
  if (digits === undefined) {
    digits = 0;
  }

  const multiplicator = Math.pow(10, digits);
  n = parseFloat((n * multiplicator).toFixed(11));
  var test =(Math.round(n) / multiplicator);
  return +(test.toFixed(2));
}



// WEBPACK FOOTER //
// ./master/jsx/components/Dispatch/shipping.jsx